export function getCalendarItemCardStepDoneTooltipKey({ canEdit, isDone }) {
  if (!canEdit) {
    return 'Calendar.NoEditTaskKey'
  }

  return isDone
    ? 'TaskTable.ActionMarkAsOpenTooltipKey'
    : 'TaskTable.ActionMarkAsDoneTooltipKey'
}
